const Content = ({ Title, AdditionalButtons, FooterText, children }) => {
  return (
    <section className="content">
      <div style={{
        background: "#fff",
        borderRadius: "14px",
        boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
        border: "1px solid #f0f0f0",
        overflow: "hidden",
      }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "18px 24px",
          borderBottom: "1px solid #f5f5f5",
        }}>
          <div style={{ fontSize: "1.15rem", fontWeight: 700, color: "#212121" }}>
            {Title ? <Title /> : null}
          </div>
          <div>
            {AdditionalButtons ? <AdditionalButtons /> : null}
          </div>
        </div>

        <div style={{ padding: "20px 24px", minHeight: "100px" }}>
          {children}
        </div>

        {FooterText && (
          <div style={{
            padding: "12px 24px",
            borderTop: "1px solid #f5f5f5",
            fontSize: "0.85rem",
            color: "#9e9e9e",
          }}>
            {FooterText}
          </div>
        )}
      </div>
    </section>
  );
};

export default Content;
